import { requestFindUnitManagement } from 'app/api/unit'
import { notificationController } from 'app/controllers/notification-controller'
import { IUnit } from 'app/model/unit.model'
import { get } from 'lodash'
import { createContext, useEffect, useState } from 'react'
/* eslint-disable @typescript-eslint/no-explicit-any */
interface IUnitContext {
  loading: boolean
  units: IUnit[] | any
  setLoading?: (loading) => void
}
export const UnitContext = createContext<IUnitContext>({
  loading: false,
  units: [],
})

export const UnitProvider = ({ children }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const units = await requestFindUnitManagement({
          keyword: '',
          typeid: 'area',
          status: 1,
          page: 0,
          pagesize: 2000,
        })
        setData(units?.data?.rows)
      } catch (error) {
        notificationController.error({ message: get(error, 'message', '') })
      }

      setLoading(false)
    }

    if (!data.length) {
      fetchData()
    }
  }, [])

  return (
    <UnitContext.Provider value={{ units: data, loading, setLoading }}>
      {children}
    </UnitContext.Provider>
  )
}
